import {AUTH_BASE_URL} from "./authApi";
import {getSessionEpoch, setAccessToken} from "../axios-config/authSession";
import {axiosPrivate} from "../axios-config/axiosPrivate";
import {standardRequestConfig} from "../axios-config/requestConfig";

/**
 * Asks for the code that unlocks this device. The backend mails it to the login address of the artist.
 * Answers: 200 sent, 429 too often, 503 no code possible, 409 device already confirmed.
 */
export const requestDeviceChallenge = () =>
    axiosPrivate.post(`${AUTH_BASE_URL}/device/challenge`, undefined, {...standardRequestConfig, withCredentials: true})

/**
 * Confirms the device with the code from the mail. The answer is a new access token with
 * `deviceConfirmed: true`; the session takes it over (the refresh token stays). A wrong code is a 403 with
 * `reason` `INVALID_CODE` or `CODE_EXPIRED`. If the session ended or changed while the answer was on its way,
 * the new token belongs to a session that is gone: it is dropped and the call fails with `SESSION_CHANGED`.
 */
export const confirmDevice = async ({code}) => {
    const epoch = getSessionEpoch()
    const response = await axiosPrivate.post(`${AUTH_BASE_URL}/device/confirm`, {code}, {...standardRequestConfig, withCredentials: true})
    if (epoch !== getSessionEpoch()) {
        throw new Error('SESSION_CHANGED')
    }
    setAccessToken(response.data.accessToken)
    return response
}
